import React, { useEffect } from "react";
import PreviewRow from "../../elements/preview-row";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import { generateReactKey } from "../../utils/reactKey";
import LoadingSpinner from "../../elements/loading-spinner";
import "./style.scss";

const SummarySection = ({ items, financingPlan }) => {
  return (
    <div className="pdp-summary-section">
      {items.map(feature => {
        return (
          <div key={generateReactKey()}>
            <PreviewRow {...feature} disclaimer={undefined} key={generateReactKey()} financingPlan={financingPlan} />
            {feature.disclaimer && <p className="feature-disclaimer">{feature.disclaimer}</p>}
          </div>
        );
      })}
    </div>
  );
};

const PdpSummary = ({ fields, features, summarySections, loanLoading, financingPlan }) => {
  const { headingType, headingBody, info, legal, summaryHeading } = fields;
  useEffect(() => { }, [summarySections, fields, features]);
  return (
    <div className="pdp-summary grid">
      <div className="heading-container">
        <Heading {...{ type: headingType || { fields: { phrase: { value: "h3" } } }, html: headingBody }} typographyClass={"type-h3"} />
      </div>
      {loanLoading && <LoadingSpinner />}
      {!loanLoading && (
        <>
          <div className="feature-list">
            {features.length > 0 && <SummarySection items={features} financingPlan={financingPlan} />}
            {summaryHeading && summaryHeading?.value && (
              <div className="order-summary-heading">
                <h4>{summaryHeading?.value}</h4>
              </div>
            )}
            {summarySections &&
              summarySections.map(section => {
                return <SummarySection items={section} key={generateReactKey()} financingPlan={financingPlan} />;
              })}
          </div>
          <div className="body info-text">
            <BodyText html={info} />
            <BodyText html={legal} />
          </div>
        </>
      )}
    </div>
  );
};

export default PdpSummary;
